//
// Modals
//
export const TOGGLE_CREATE_MARKET_MODAL = "TOGGLE_CREATE_MARKET_MODAL";
export const TOGGLE_INFO_MODAL = "TOGGLE_INFO_MODAL";

//
// Contracts
//
export const CREATE_MARKET_CONTRACT = "CREATE_MARKET_CONTRACT";
